import React from 'react'
import { Box } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useForm, useWatch } from 'react-hook-form'
import { ConsumptionType } from './usage-matrix-util'
import { ControlledRadioGroup } from '../../form/ControlledRadioGroup'
import { ControlledHourPicker } from '../../form/ControlledHourPicker'

export type FormValues = {
  consumptionType: ConsumptionType
  date: Date
}

type Props = {
  startOfYearDate: Date
  defaultValues?: Partial<FormValues>
  onSubmit: (values: FormValues) => void
}

export function UsageMatrixControls({
  startOfYearDate,
  defaultValues,
  onSubmit,
}: Props): React.ReactElement {
  const { control, handleSubmit } = useForm<FormValues>({ defaultValues })
  const { t } = useTranslation()
  const consumptionType = useWatch({ control, name: 'consumptionType' })

  return (
    <Box display="flex" alignItems="center" mb={4}>
      <ControlledRadioGroup
        control={control}
        name="consumptionType"
        options={[
          {
            value: ConsumptionType.TotalEnergy,
            label: t('usageMatrix.totalEnergyConsumption'),
          },
          {
            value: ConsumptionType.HourlyPower,
            label: t('usageMatrix.hourlyPower'),
          },
        ]}
        onChange={handleSubmit(onSubmit)}
      />

      <Box
        display={
          consumptionType === ConsumptionType.HourlyPower ? 'block' : 'none'
        }
      >
        <ControlledHourPicker
          control={control}
          name="date"
          label={t('usageMatrix.date')}
          defaultValue={startOfYearDate}
          startOfYearDate={startOfYearDate}
          onChange={handleSubmit(onSubmit)}
        />
      </Box>
    </Box>
  )
}
